import { v4 } from 'uuid';
import z from 'zod';

const stringifiedId = z.preprocess(val => typeof val === "number" ? String(val) : val, z.string());

/**
 * Specification of the response format for form based steps.
 */

/**
 * Specification of the response format for form based steps.
 */

const formTaskSchema = z.object({
  type: z.literal("form"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  alignment: z.enum(["left", "top", "right", "bottom"]).nullish().default("left"),
  guideFieldWidth: z.union([z.literal("auto"), z.preprocess(val => Number(val), z.number())]).optional(),
  guide: z.string(),
  inputs: z.array(z.object({
    id: stringifiedId.default("undefined"),
    type: z.enum(["input", "text"]),
    text: z.string(),
    predefinedAnswer: z.string().optional(),
    showFormatted: z.boolean().optional()
  }))
});

/**
 * @legacy Specification of the response format for editor based steps.
 */

const transformEditorTaskToFormTaskSchema = z.object({
  type: z.literal("editor"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  alignment: z.enum(["left", "top", "right", "bottom"]).nullish().default("left"),
  guideFieldWidth: z.union([z.literal("auto"), z.preprocess(val => Number(val), z.number())]).optional(),
  guide: z.string(),
  editorTitle: z.string().optional(),
  contents: z.string().optional()
}).transform(editorTask => ({
  type: "form",
  id: editorTask.id,
  title: editorTask.title ?? null,
  alignment: editorTask.alignment,
  guideFieldWidth: editorTask.guideFieldWidth,
  guide: editorTask.guide,
  inputs: [{
    type: "text",
    text: editorTask.editorTitle,
    id: "input",
    maxLengthType: "characters",
    showFormatted: true,
    predefinedAnswer: editorTask.contents
  }]
}));

/**
 * @legacy Specification of the response format for guide based steps.
 */

const transformGuideTaskToFormTaskSchema = z.object({
  type: z.literal("info"),
  id: stringifiedId.default(() => v4()),
  title: z.string().nullish().default(null),
  guide: z.string()
}).transform(editorTask => ({
  type: "form",
  id: editorTask.id,
  title: editorTask.title ?? null,
  alignment: "left",
  guideFieldWidth: "auto",
  guide: editorTask.guide,
  inputs: []
}));
const iGuideDataSchema = z.object({
  description: z.string(),
  tasks: z.array(z.union([formTaskSchema, transformEditorTaskToFormTaskSchema, transformGuideTaskToFormTaskSchema])),
  settings: z.object({
    enableBackground: z.boolean().default(false),
    formatting: z.array(z.string()).optional(),
    languages: z.array(z.string().optional().transform(lang => lang !== undefined ? transformLang(lang) : undefined)).optional(),
    latexParser: z.string().optional()
  })
});
function transformLang(lang) {
  switch (lang) {
    case "fr":
      return "French";
    case "de":
      return "German";
    case "en":
      return "English";
    case "es":
      return "Spanish";
    case "da":
    default:
      return "Danish";
  }
}

export { iGuideDataSchema };
//# sourceMappingURL=i-guide.component-data.js.map
